module.exports = __webpack_public_path__ + "img/app_icon_danger_tip.77f86c9a.png";